module.exports = __webpack_public_path__ + "assets/img/loanstar.71624270.png";